export default __webpack_public_path__ + "static/media/Koenigsretter_Dynastie_1_Hoerprobe.01198631.mp3";